<template>
  <div class="lang_selector" v-click-outside="closeOutside">
    <button
      class="lang_btn gap-5 medium-s font-family-2"
      :class="[isOpen && 'opened']"
      style="padding: 3px 12px"
      @click="toggleOpen"
    >
      <img
        :src="selectedLang.image"
        alt="Country language flag"
        class="language_image"
        height="30"
        width="30"
      />
    </button>

    <Transition
      :name="windowInnerWidth <= 1200 ? 'profile_menu-mobile' : 'lang_menu'"
    >
      <LazyCustomLangContainer
        v-if="isOpen"
        :langs="langs"
        :selectedLang="selectedLang"
        :changeLanguage="changeLanguage"
      />
    </Transition>
  </div>
</template>

<script setup>
// HOOKS
const { locale, setLocale } = useI18n();

// REACTIVE VARIABLES
const isOpen = ref(false);
const selectedLang = ref(langs.find((lang) => lang.param === locale.value));

const compLang = computed(() => locale.value);
// METHODS
const closeOutside = () => {
  isOpen.value = false;
};
const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

const changeLanguage = (locale) => {
  setLocale(locale);
  let locLang = langs.find((lang) => lang.param === locale);
  selectedLang.value = locLang;
  toggleOpen();
};
const windowInnerWidth = computed(() => {
  if (!window?.innerWidth) {
    return 0;
  } else return window.innerWidth;
});
</script>
